import * as React from "react";

type IconProps = {
  size?: number;
  stroke?: number;
  className?: string;
  style?: React.CSSProperties;
};

function stroke(paths: string[]) {
  return function Icon({ size = 16, stroke: sw = 1.8, className, style }: IconProps) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={sw}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        style={style}
        aria-hidden
      >
        {paths.map((d, i) => (
          <path key={i} d={d} />
        ))}
      </svg>
    );
  };
}

export const IconBold = stroke(["M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z", "M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"]);
export const IconItalic = stroke(["M19 4h-9", "M14 20H5", "M15 4L9 20"]);
export const IconList = stroke(["M8 6h13", "M8 12h13", "M8 18h13", "M3 6h.01", "M3 12h.01", "M3 18h.01"]);
export const IconOrderedList = stroke([
  "M10 6h11",
  "M10 12h11",
  "M10 18h11",
  "M4 6h1v4",
  "M4 10h2",
  "M6 18H4c0-1 2-2 2-3s-1-1.5-2-1",
]);
export const IconLink = stroke(["M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71", "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"]);
export const IconX = stroke(["M18 6L6 18", "M6 6l12 12"]);
export const IconLocate = stroke([
  "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z",
  "M12 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
]);
export const IconComment = stroke([
  "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
]);
export const IconChevronDown = stroke(["M6 9l6 6 6-6"]);
export const IconUser = stroke(["M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2", "M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"]);
